import { render, staticRenderFns } from "./ortu.vue?vue&type=template&id=726a99a0"
import script from "./ortu.vue?vue&type=script&lang=js"
export * from "./ortu.vue?vue&type=script&lang=js"
import style0 from "./ortu.vue?vue&type=style&index=0&id=726a99a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports